import React, { Component } from 'react';
import { MembershipTypeRow, RowItem, InputBox } from './style';
import { TruncatedText } from '../../../UI/Text';
import { Icon } from '../../Icons/Icons';
import { DatePickerComponent } from '../../Pickers/DatePicker';
import { Select } from '../../Select';
import { SelectContainer } from '../MemberRow/style';
import { getTomorrow, convertDateToServerDateTypeMoment } from '../../../../Utils/timeConvertorHelper';
import { TransparentInput } from '../../Inputs/InvisibleInput/style';
import debounce from 'lodash.debounce';
import { SelectItemComponent, CheckMark } from '../../Items/SelectItems/SelectItemComponent';
import { HoverableFadingContainer } from '../../HoverableFadingContainer';
import {
    setCredits,
    setExpiry,
    setClassLimit,
    getCredits,
    getExpiry,
    getAvailableClasses,
    selectInputOnFocus,
    getClassLimit,
    setAvailableClasses,
    getRegularity,
} from './utils';
import { MultipleSelect } from '../../MultipleSelect';

const TEXT_HOVER_STYLE = 'font-weight: bold';
const TEXT_TRANSITION = 'all 0.25s ease-out';
const DATE_FORMAT = 'MMMM d, yyyy';

const expiryTypes = [{ value: 0, title: 'None' }, { value: 1, title: 'From issue' }, { value: 2, title: 'Fixed date' }];

const days = [...Array(364)].map((item, index) => {
    return { value: index + 1, title: `${index + 1} ${index + 1 === 1 ? 'day' : 'days'}` };
});

const classLimitTypes = [
    { value: 0, title: 'Unlimited ' },
    { value: 1, title: 'Credits based' },
    { value: 2, title: 'Online only' },
];

const regularityTypes = [
    { value: 0, title: 'One off payment' },
    { value: 1, title: 'Every month' },
    { value: 2, title: '1st and 15th' },
    { value: 3, title: '10th and 25th' },
    { value: 4, title: 'Every week' },
    { value: 5, title: 'Every 2 weeks' },
    { value: 6, title: 'Every 3 weeks' },
    { value: 7, title: 'Every 4 weeks' },
    { value: 8, title: 'Every 1 month' },
    { value: 9, title: 'Every 2 months' },
    { value: 10, title: 'Every 3 months' },
    { value: 11, title: 'Every 4 months' },
    { value: 12, title: 'Every 6 months' },
];

export class MembershipPlanRow extends Component {
    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) this.setState(this.getState());
    }

    updatePlan = () => {
        const { expiry, id: planId, credits, classLimit, ...requestObject } = this.state;
        const { id, updatePlan } = this.props;

        switch (expiry) {
            case 0: {
                requestObject.deadline_date = null;
                requestObject.deadline_days = null;
                break;
            }
            case 1: {
                requestObject.deadline_date = null;
                break;
            }
            case 2: {
                requestObject.deadline_days = null;
                break;
            }
            default:
                break;
        }

        switch (classLimit) {
            case 0: {
                requestObject.credits = null;
                break;
            }
            case 1: {
                requestObject.credits = credits;
                break;
            }
            case 2: {
                requestObject.online_only = true;
                break;
            }
            default:
                break;
        }

        updatePlan(id, requestObject);
    };

    requestWithDelay = debounce(() => {
        this.updatePlan();
    }, 250);

    // inputs change
    handleChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value }, this.requestWithDelay());
    };

    handleDateChange = date => {
        this.setState({ deadline_date: convertDateToServerDateTypeMoment(date) }, () => this.updatePlan());
    };

    // toggle
    toggleDaysWindow = () => {
        const { toggleDaysWindow, id } = this.props;
        toggleDaysWindow(id);
    };

    toggleExpiryWindow = () => {
        const { toggleExpiryWindow, id } = this.props;
        toggleExpiryWindow(id);
    };

    toggleClassLimitWindow = () => {
        const { toggleClassLimitWindow, id } = this.props;
        toggleClassLimitWindow(id);
    };

    toggleClassesWindow = () => {
        const { toggleClassesWindow, id } = this.props;
        toggleClassesWindow(id);
    };

    toggleUsageLimitWindow = () => {
        const { toggleUsageLimitWindow, id } = this.props;
        toggleUsageLimitWindow(id);
    };

    toggleRegularityWindow = () => {
        const { toggleRegularityWindow, id } = this.props;
        toggleRegularityWindow(id);
    };

    // select
    selectClassLimit = classLimit => {
        const { toggleClassLimitWindow } = this.props;

        this.setState({ classLimit: classLimit.value }, () => {
            if (classLimit === 1)
                this.setState({ credits: 1 }, () => {
                    toggleClassLimitWindow(null);
                    this.updatePlan();
                });

            this.toggleClassLimitWindow(null);
            this.updatePlan();
        });
    };

    selectExpiry = expiry => {
        const { toggleExpiryWindow } = this.props;

        this.setState({ expiry: expiry.value }, () => {
            toggleExpiryWindow(null);
            this.updatePlan();
        });
    };

    selectDays = deadline_days => {
        const { toggleDaysWindow } = this.props;

        this.setState({ deadline_days: deadline_days.value }, () => {
            toggleDaysWindow(null);
            this.updatePlan();
        });
    };

    selectClass = classSelected => {
        const { assignClassesToPlan, id } = this.props;

        this.setState(
            prevState => {
                return {
                    ...prevState,
                    availableClasses: [...prevState.availableClasses, classSelected],
                };
            },
            () => {
                const mappedIds = this.state.availableClasses.map(_class => _class.value);
                assignClassesToPlan(id, mappedIds);
            },
        );
    };

    unselectClass = classSelected => {
        const { assignClassesToPlan, id } = this.props;

        this.setState(
            prevState => {
                return {
                    ...prevState,
                    availableClasses: prevState.availableClasses.filter(_class => _class.value !== classSelected.value),
                };
            },
            () => {
                const mappedIds = this.state.availableClasses.map(_class => _class.value);
                assignClassesToPlan(id, mappedIds);
            },
        );
    };

    selectRegularity = regularity => {
        const { toggleRegularityWindow } = this.props;
        this.setState({ regularity: regularity.value }, () => {
            toggleRegularityWindow(null);
            this.updatePlan();
        });
    };

    // delete
    deleteMembershipPlan = () => {
        const { id, deletePlan } = this.props;
        deletePlan(id);
    };

    getState = () => ({
        id: this.props.id,
        name: this.props.name || 'Untitled plan',
        credits: setCredits(this.props.credits),
        expiry: setExpiry(this.props.deadlineDate, this.props.deadlineDays),
        classLimit: setClassLimit(this.props.credits, this.props.isOnlineOnly),
        deadline_date: this.props.deadlineDate ? this.props.deadlineDate.date : getTomorrow(),
        deadline_days: this.props.deadlineDays || 1,
        auto_renew: false,
        availableClasses: setAvailableClasses(this.props.allowedClasses),
        price: this.props.price ? this.props.price : 1,
        payments_count: this.props.paymentsCount ? this.props.paymentsCount : 1,
        signup_fee: this.props.signupFee,
        regularity: this.props.regularity,
    });

    state = {
        ...this.getState(),
    };

    mapClassesToMultipleSelect = () => {
        const { classesForPlans } = this.props;
        const newArray = classesForPlans.map(_class => {
            return { title: _class.name, value: _class.seriesId };
        });

        return newArray;
    };

    render() {
        const {
            props: {
                id,
                daysWindowOpenId,
                expiryWindowOpenId,
                classLimitWindowOpenId,
                classesWindowOpenId,
                regularityWindowOpenId,
                onCloseAll,
            },
            state: {
                name,
                credits,
                expiry,
                deadline_date,
                deadline_days,
                classLimit,
                availableClasses,
                price,
                payments_count,
                signup_fee,
                regularity,
            },
            handleChange,
            handleDateChange,
            toggleDaysWindow,
            toggleExpiryWindow,
            toggleClassLimitWindow,
            toggleClassesWindow,
            toggleRegularityWindow,
            deleteMembershipPlan,
        } = this;

        const isDaysWindowOpen = daysWindowOpenId === id;
        const isExpiryWindowOpen = expiryWindowOpenId === id;
        const isClassLimitWindowOpen = classLimitWindowOpenId === id;
        const isClassesWindowOpen = classesWindowOpenId === id;
        // const isUsageLimitWindowOpen = usageLimitWindowOpenId === id;
        const isRegularityWindowOpen = regularityWindowOpenId === id;

        const availableClassesForCheck = this.mapClassesToMultipleSelect();

        return (
            <MembershipTypeRow>
                <RowItem minWidth={'200px'}>
                    <TransparentInput
                        onFocus={selectInputOnFocus}
                        onChange={handleChange}
                        name={'name'}
                        value={name}
                        autoComplete={'off'}
                    />
                </RowItem>

                <RowItem minWidth={'120px'}>
                    <HoverableTruncatedText onClick={toggleClassLimitWindow}>
                        {getClassLimit(classLimit)}
                    </HoverableTruncatedText>

                    {isClassLimitWindowOpen && (
                        <Select
                            onClose={onCloseAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectClassLimit}
                            available={classLimitTypes}
                            selected={classLimit}
                        />
                    )}
                </RowItem>

                <RowItem minWidth={'80px'}>
                    <InputBox
                        value={getCredits(credits, classLimit)}
                        name={'credits'}
                        onChange={handleChange}
                        disabled={!classLimit || classLimit === 2}
                    />
                </RowItem>

                {/* <RowItem minWidth={'150px'}>
                    <Row>
                        <InputBox value={usageLimit} name={'usageLimit'} onChange={handleChange} />
                        <HoverableTruncatedText marginLeft={'20px'}>Per week</HoverableTruncatedText>
                    </Row>
                </RowItem> */}

                <RowItem minWidth={'100px'}>
                    <HoverableTruncatedText onClick={toggleExpiryWindow}>{getExpiry(expiry)}</HoverableTruncatedText>

                    {isExpiryWindowOpen && (
                        <Select
                            onClose={onCloseAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectExpiry}
                            available={expiryTypes}
                            selected={expiry}
                        />
                    )}
                </RowItem>

                <RowItem minWidth={'150px'}>
                    <ExpirationDateComponent
                        handleDateChange={handleDateChange}
                        toggleDaysWindow={toggleDaysWindow}
                        deadlineDays={deadline_days}
                        deadlineDate={deadline_date}
                        expirationType={expiry}
                    />

                    {isDaysWindowOpen && (
                        <Select
                            onClose={onCloseAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectDays}
                            available={days}
                            selected={deadline_days}
                        />
                    )}
                </RowItem>

                <RowItem minWidth={'80px'}>
                    <InputBox type={'number'} value={price} name={'price'} onChange={handleChange} />
                </RowItem>

                <RowItem minWidth={'135px'}>
                    <HoverableTruncatedText onClick={toggleRegularityWindow}>
                        {getRegularity(regularity)}
                    </HoverableTruncatedText>

                    {isRegularityWindowOpen && (
                        <Select
                            onClose={onCloseAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectRegularity}
                            available={regularityTypes}
                            selected={regularity}
                        />
                    )}
                </RowItem>

                <RowItem minWidth={'120px'}>
                    <InputBox type={'number'} value={payments_count} name={'payments_count'} onChange={handleChange} />
                </RowItem>

                <RowItem minWidth={'100px'}>
                    <InputBox type={'number'} value={signup_fee} name={'signup_fee'} onChange={handleChange} />
                </RowItem>

                <RowItem minWidth={'200px'}>
                    <HoverableTruncatedText onClick={toggleClassesWindow} opacity={0.8} weight={100}>
                        {getAvailableClasses(availableClasses)}
                    </HoverableTruncatedText>

                    {isClassesWindowOpen && (
                        <MultipleSelect
                            onClose={onCloseAll}
                            container={SelectContainer}
                            item={SelectItemComponent}
                            check={CheckMark}
                            onSelect={this.selectClass}
                            onUnselect={this.unselectClass}
                            available={availableClassesForCheck}
                            selected={availableClasses}
                        />
                    )}
                </RowItem>

                <RowItem minWidth={'50px'}>
                    <HoverableFadingContainer>
                        <Icon.Box onClick={deleteMembershipPlan} cursor={'pointer'} size={'24x24'}>
                            <Icon.Delete />
                        </Icon.Box>
                    </HoverableFadingContainer>
                </RowItem>
            </MembershipTypeRow>
        );
    }
}

const ExpirationDateComponent = ({
    expirationType,
    deadlineDays,
    deadlineDate,
    handleDateChange,
    toggleDaysWindow,
}) => {
    switch (expirationType) {
        case 0:
            return (
                <TruncatedText opacity={0.8} weight={100}>
                    None
                </TruncatedText>
            );
        case 1:
            return (
                <HoverableTruncatedText onClick={toggleDaysWindow}>
                    {deadlineDays} {deadlineDays === 1 ? 'day' : 'days'}
                </HoverableTruncatedText>
            );
        case 2:
            return (
                <DatePickerComponent
                    dateFormat={DATE_FORMAT}
                    selected={new Date(deadlineDate)}
                    onChange={handleDateChange}
                    customInput={<CustomDateInput />}
                />
            );
        default:
            return null;
    }
};

const CustomDateInput = ({ onClick, value }) => (
    <HoverableTruncatedText onClick={onClick}>{value || 'Select a date'}</HoverableTruncatedText>
);

const HoverableTruncatedText = ({ children, ...props }) => (
    <TruncatedText
        cursor={'pointer'}
        hover={TEXT_HOVER_STYLE}
        transition={TEXT_TRANSITION}
        opacity={0.8}
        weight={100}
        {...props}
    >
        {children}
    </TruncatedText>
);

MembershipPlanRow.defaultProps = {
    classesForPlans: [],
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MembershipPlanRow/index.js